import { Observable } from 'rxjs';
import type {
  BpnLookupResponse,
  OrganizationLookupResponse,
  OrganizationSearchResult
} from '../models/discovery.model';

/**
 * Stable domain contract for dataspace participant discovery (BPN ↔ connector ↔ organization).
 * Implemented by AdessoDiscoveryApiAdapter against the adesso-connector-api.
 * Server-side SPI (`discovery-spi` in htx-tx-connector-cp) allows swapping backends (HT-X mock, BDRS, etc.).
 */
export abstract class DiscoveryApiPort {
  abstract getConnectorByBpnl(bpnl: string): Observable<BpnLookupResponse>;
  abstract getOrganizationByBpnl(bpnl: string): Observable<OrganizationLookupResponse>;
  abstract searchOrganizations(organizationName: string): Observable<OrganizationSearchResult[]>;
}
